// @flow
export { default } from './WriteSelectLayouts';



// WEBPACK FOOTER //
// ./src/components/write/WriteSelectLayouts/index.js